import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function ChartIcon(iconProps: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width={iconProps.width}
      height={iconProps.height}
      viewBox={`0 0 ${iconProps.width} ${iconProps.height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.2724 16.5154H27.7102C28.1885 16.0275 28.8079 15.6785 29.5023 15.5345C29.1736 8.45218 23.3276 2.81113 16.164 2.81113C8.78943 2.81113 2.81116 8.7894 2.81116 16.164C2.81116 23.3028 8.41334 29.1332 15.4612 29.4987V27.4085L15.4613 27.3869C9.57847 27.0241 4.9195 22.1381 4.9195 16.164C4.9195 10.0714 9.76504 5.1105 15.8126 4.92486V14.0556C15.8126 15.4141 16.9139 16.5154 18.2724 16.5154ZM18.2724 14.407C18.0783 14.407 17.921 14.2497 17.921 14.0556V5.05593C22.7241 5.80959 26.5184 9.60386 27.2721 14.407H18.2724ZM30.2196 16.8668C29.0552 16.8668 28.1113 17.8107 28.1113 18.9751V30.2196C28.1113 31.384 29.0552 32.328 30.2196 32.328C31.3841 32.328 32.328 31.384 32.328 30.2196V18.9751C32.328 17.8107 31.3841 16.8668 30.2196 16.8668ZM18.9751 25.3001C17.8107 25.3001 16.8668 26.2441 16.8668 27.4085V30.2196C16.8668 31.384 17.8107 32.328 18.9751 32.328C20.1395 32.328 21.0835 31.384 21.0835 30.2196V27.4085C21.0835 26.2441 20.1395 25.3001 18.9751 25.3001ZM22.489 23.1918C22.489 22.0274 23.433 21.0835 24.5974 21.0835C25.7618 21.0835 26.7057 22.0274 26.7057 23.1918V30.2196C26.7057 31.384 25.7618 32.328 24.5974 32.328C23.433 32.328 22.489 31.384 22.489 30.2196V23.1918Z'
        fill={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
      />
    </svg>
  )
}
